module.exports = __webpack_public_path__ + "img/VectorByte-logo-alt.2783fd2c.svg";